"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalTicketItemSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("../display/widgets/common");
exports.VerticalTicketItemSchema = zod_1.z.object({
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
    id: zod_1.z.string(),
    action: common_1.CommonResponseItemActionDto,
    image: zod_1.z.object({
        width: zod_1.z.number(),
        height: zod_1.z.number(),
        unit: zod_1.z.enum(['FLEXIBLE', 'FIXED']),
        url: zod_1.z.string(),
    }),
    position: zod_1.z
        .object({
        latitude: zod_1.z.number(),
        longitude: zod_1.z.number(),
    })
        .nullable(),
    discountBadge: common_1.CommonResponseItemPropertyDto.nullable(),
    locationDescription: common_1.CommonResponseItemPropertyDto.nullable(),
    ranking: common_1.CommonResponseItemPropertyDto,
    memberClassBadge: common_1.CommonResponseItemPropertyDto.nullable(),
    review: common_1.CommonResponseItemReviewDto.nullable(),
    caption: common_1.CommonResponseItemCaptionDto.nullable(),
    badges: zod_1.z.array(common_1.CommonResponseItemPropertyDto).optional(),
    title: common_1.CommonResponseItemPropertyDto,
    description: common_1.CommonResponseItemPropertyDto.nullable(),
    location: common_1.CommonResponseItemPropertyDto.nullable(),
    benefits: zod_1.z.array(common_1.CommonResponseItemBenefitDto).optional(),
    availableQuantity: common_1.CommonResponseItemBenefitDto.nullable(),
    features: zod_1.z.array(common_1.CommonResponseItemPropertyDto),
    prices: zod_1.z.array(common_1.CommonResponseItemPropertyDto).nullable(),
    notices: zod_1.z.array(common_1.CommonResponseItemBenefitDto).nullable(),
});
